import { Flex, Space, Typography } from "antd";
import FormattedMessage from "components/common/FormattedMessage";
import StandardButton from "components/common/StandardButton";
import { Text } from "components/common/StandardText";
import useSimpleBreakpoint from "services/hooks/useSimpleBreakpoint";

interface ReviewAICheckProps {
    setStars: (stars: number) => void;
    setUseAI: (useAI: boolean) => void;
    onBack: () => void;
}

const ReviewAICheck = ({ setUseAI, onBack }: ReviewAICheckProps) => {
    const [s, si, isMobile] = useSimpleBreakpoint();

    return (
        <Flex vertical align="center" justify="center" style={{ width: "100%" }}>
            <Space direction="vertical" align="center" style={{ width: "100%" }}>
                <Typography.Title level={3}>
                    <FormattedMessage
                        id="standalone.reviews.thankYouAfterGoodRatingMessage"
                        defaultMessage="Thank you!"
                        description="Reviews: Tytuł po dobrej ocenie"
                    />
                </Typography.Title>
                <Text style={{ display: "block", width: "100%", textAlign: "center" }}>
                    <FormattedMessage
                        id="standalone.reviews.wouldYouLikeToUseAI.question"
                        defaultMessage="Would you like our AI agent to help you write a review?"
                        description="Reviews: Pytanie o użycie AI"
                    />
                </Text>


                <Flex vertical={isMobile} gap="small" style={{ width: "100%" }}>
                    <StandardButton onClick={onBack} block>
                        <FormattedMessage
                            id="standalone.reviews.aiCheck.back"
                            defaultMessage="Back"
                            description="Reviews: Przycisk powrodu z kroku użycia AI"
                        />
                    </StandardButton>

                    <StandardButton onClick={() => setUseAI(false)} block>
                        <FormattedMessage
                            id="standalone.reviews.aiCheck.no"
                            defaultMessage="I will write it myself"
                            description="Reviews: Przycisk nie używania AI"
                        />
                    </StandardButton>

                    <StandardButton onClick={() => setUseAI(true)} type="primary" block>
                        <FormattedMessage
                            id="standalone.reviews.aiCheck.yes"
                            defaultMessage="I want to use AI"
                            description="Reviews: Przycisk używania AI"
                        />
                    </StandardButton>
                </Flex>
            </Space>
        </Flex>
    );
};

export default ReviewAICheck;
